import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { Dropdown } from 'react-bootstrap';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { CatValidateFields } from '../validate/categoryValidation';
import ErrorFilter from '../../helper/errorFilter';
import { updateCategory } from '../../controller';
import { requestHandler } from '../../helper';
import { toast } from 'react-toastify';
import SingleError from '../../helper/SingleError';


function CategoryEdit({ id, categoryData, getCategoryData }) {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const [errors, setErrors] = useState({});
    const [submitCount, setSubmitCount] = useState(0);

    const requireField = [
        "name",
    ];

    const [formData, setFormData] = useState({
        name: '',
        status: true
    });


    const handleShow = () => {
        setShow(true);
        handleEditUser(id);
    };

    const handleEditUser = async (id) => {
        const category = categoryData.find(cat => cat._id === id);
        setFormData({
            name: category.name,
            status: category.status
        })

    }

    const handleChange = async (e) => {
        const { name, value, checked, type } = e.target;
        let newValue = type === "checkbox" ? checked : value;
        if (submitCount > 0) {
            let validationErrors = CatValidateFields({ ...formData, [name]: value });
            validationErrors = ErrorFilter(validationErrors, requireField);
            setErrors(validationErrors);
            if (Object.keys(validationErrors).length === 0) {
                delete errors[name];
            }
        }
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission
        setSubmitCount(prevCount => prevCount + 1);
        const updatedValues = { ...formData };

        let validationErrors = CatValidateFields(updatedValues);
        validationErrors = ErrorFilter(validationErrors, requireField);
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length === 0) {
            await requestHandler(
                async () => await updateCategory(updatedValues, id),
                null,
                (res) => {
                    toast.success(res.message);
                    handleClose();
                    setFormData({
                        name: '',
                        status: true
                    });
                    getCategoryData();
                },
                () => { }
            )

        }
    }

    return (
        <>
            <OverlayTrigger
                key="tooltip"
                placement="top"
                overlay={<Tooltip id={`tooltip-top`}>Edit</Tooltip>}
            >
                <button className='border-0' onClick={handleShow}>
                    <img src="../images/png/edit.png" alt="" />
                </button>
            </OverlayTrigger>


            <Modal className='modal-main' show={show} centered size='md' onHide={handleClose}>
                <Modal.Body>
                    <Modal.Title>
                        <div className="row justify-content-center">
                            <div className="col-11 col-8">
                                <h2>Edit Category</h2>
                            </div>
                        </div>
                    </Modal.Title>
                    <div className='modal-form'>
                        <Form>
                            <Form.Group className="mb-3" controlId="formGroupEmail">
                                <Form.Label>Category Name</Form.Label>
                                <Form.Control type="text" placeholder="Edit Category" name="name" value={formData.name} onChange={handleChange} />
                                <SingleError error={errors?.name} />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formGroupPassword">
                                <Form.Label>Status</Form.Label>
                                <Dropdown className='status-btn'>
                                    <Dropdown.Toggle id="dropdown-basic">
                                        {formData.status ? 'Active' : 'Deactive'}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => setFormData({ ...formData, status: true })}>Active</Dropdown.Item>
                                        <Dropdown.Item onClick={() => setFormData({ ...formData, status: false })}>Deactive</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Form.Group>
                            <div className='d-md-flex align-items-center gap-3 mt-4'>
                                <button className='cancel-btn' onClick={handleClose} type='button' onHide={handleClose}>Cancel</button>
                                <button className='save-btn' type='button' onClick={handleSubmit}>Update</button>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default CategoryEdit